import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class LoadingService {
	isLoading: boolean = false;

	async showLoading(): Promise<void> {
		this.isLoading = true;
	}

	hideLoading(): void {
		this.isLoading = false;
	}
}
